export const config = {
  tokenPath: 'oauth/token',
  defaultAuthRealm: process.env.REACT_APP_DEFAULT_AUTH_REALM || '', // fallback points to same host as client
  messages: {
    genericError: 'Something went wrong. Please try again.',
    connectionProblemError: 'Could not connect to the server. Please try again later.',
    incorrectCredentials: 'Provided credentials are incorrect.',
    sessionExpired: 'Your session has expired. Please log in again.',
    emailAlreadyExists: 'This email address is already taken. Please try another.',
    dependentOncePerHourError: 'You can invite the same dependent only once per hour.',
  },
};
